import * as React from "react";

const MutedLink = ({
  href,
  children,
}: {
  href: string;
  children: React.ReactNode;
}) => (
  <a className="link-secondary" href={href} rel="noreferrer" target="_blank">
    {children}
  </a>
);

export default MutedLink;
